import React, { useState, useEffect } from 'react';
import Handle from './Handler';
import { validations } from './validations';
import NodeWrapper from './NodeWrapper';
import { Grid } from '@material-ui/core';
import Icon from './Icon';

const CustomInput = (props) => {

    const [protocol, setProtocol] = useState('');

    useEffect(() => {

        // const config = delegateTypes.find(type => type.value == props.data.protocol);
        // setProtocol(config);

    }, [])
    const titleStyle = {
        display: 'block',
        textAlign: 'center',
        marginTop: '84px',
        color: '#000',
        fontWeight: 600
    }
    const labelStyle = {
        marginLeft: '-90px',
        width: '150px',
        height: '200px',
        display: 'block',
        textAlign: 'center',
        marginTop: '-124px'
    }

    return (
        <>
            <NodeWrapper {...props}>

                <div className='hex2 external_function_node_123 hor-delegate'>
                    <Icon icon={protocol.icon} iconPath={'delegate_icons'} defaultIcon={'default_delegate_icon'} />
                    {/* <Handle type="target" className="external_function_left_handler_123" node="external_function" position="left" isValidConnection={validations('target', 'external_function')} id="left" /> */}
                    <Handle type="source" className="external_function_right_handler_123" node="external_function" position="right" isValidConnection={validations('source', 'external_function')} id="right" />
                    <Grid container spacing={1} style={labelStyle}>
                        <Grid item xs={12}><p style={titleStyle}>{props.data.label}</p></Grid>
                        {protocol && <Grid className={'delegate_protocol'} style={{ color: '#000' }} item xs={12}>{protocol?.label}</Grid>}
                    </Grid>
                </div>


            </NodeWrapper>
        </>
    );
};

export default CustomInput;
